export enum ErrorTypes {
	UPLOAD_FAILED = 'UPLOAD_FAILED',
	FILE_SIZE_LIMIT = 'FILE_SIZE_LIMIT',
	FILE_WIDTH_HEIGHT_LARGE = 'FILE_WIDTH_HEIGHT_LARGE',
	FILE_WIDTH_HEIGHT_SMALL = 'FILE_WIDTH_HEIGHT_SMALL',
}

export type FileDimensions = { maxW: number; maxH: number; minW?: number; minH?: number };

export function validateImageDimensions(width: number, height: number, limits?: FileDimensions): ErrorTypes | '' {
	if (!limits) return '';
	if (width > limits.maxW || height > limits.maxH) return ErrorTypes.FILE_WIDTH_HEIGHT_LARGE;
	if (width < (limits.minW ?? 0) || height < (limits.minH ?? 0)) return ErrorTypes.FILE_WIDTH_HEIGHT_SMALL;
	return '';
}
